import { ReactComponent as SignOutIcon } from '@assets/icons/sign-out.svg';
import { logout } from 'actions/auth';
import { ROUTES } from 'constant';

import { Collapse, Stack, useTheme } from '@chakra-ui/react';

import { useAppDispatch } from 'store/hooks';

import { Button, Link } from 'ui';

interface TabletNavigationProps {
  isOpen: boolean;
  handleToggle: () => void;
}

const links = [
  { to: ROUTES.appointments, label: 'My Appointments' },
  { to: ROUTES.giftCards, label: 'My Gift Cards' },
  { to: ROUTES.profile, label: 'My Account' }
];

const TabletNavigation = ({ isOpen, handleToggle }: TabletNavigationProps) => {
  const {
    colors: {
      palette: {
        components: {
          headerColor: { tabletNavigation }
        }
      }
    }
  } = useTheme();
  const dispatch = useAppDispatch();

  const linkStyles = {
    fontFamily: 'main',
    fontSize: '13px',
    textTransform: 'uppercase',
    color: tabletNavigation.linkColor,
    paddingStart: '53px',
    paddingEnd: '30px',
    paddingY: '9px'
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <Collapse
      in={isOpen}
      style={{
        display: 'block',
        position: 'absolute',
        width: '100%',
        marginTop: '1px',
        padding: '0',
        backgroundColor: tabletNavigation.bgColor,
        zIndex: 20
      }}
    >
      <Stack gap={0} py='9px'>
        {links.map((link) => (
          <Button
            key={link.to}
            w='auto'
            p={0}
            justifyContent='flex-start'
            variant='text'
            onClick={handleToggle}
          >
            <Link to={link.to} sx={linkStyles}>
              {link.label}
            </Link>
          </Button>
        ))}

        <Button
          variant='link'
          justifyContent='start'
          color={tabletNavigation.buttonColor}
          fontSize='12px'
          iconSpacing='11px'
          padding='9px 30px 9px 53px'
          onClick={handleLogout}
          leftIcon={
            <SignOutIcon
              width={13}
              height={13}
              fill={tabletNavigation.buttonColor}
            />
          }
        >
          sign out
        </Button>
      </Stack>
    </Collapse>
  );
};

export default TabletNavigation;
